module.exports = __webpack_public_path__ + "static/media/beaconHome-768w.566a21c6.jpg";